'use client'
import { useEngine } from '@/contexts/DashboardContextProvider/DashboardContextProvider'
import Link from 'next/link'

import { TopBar, TopBarHeader } from '/components/TopBar/TopBar'
import PageContent from '@/components/PageContent/PageContent'
import Calendar from '@/components/Calendar/Calendar'
import Button from '@/components/Button/Button'
import Icon from '@/components/Icon/Icon'

import styles from '@/styles/index.module.scss'
import classNames from 'classnames/bind'

const classes = classNames.bind(styles)

const Index = () => {
    const {
        state: {
            user: { firstName },
        },
    } = useEngine()

    return (
        <>
            <TopBar>
                <TopBarHeader
                    heading={`Welcome ${firstName ? firstName : ''}`}
                    subText="This is your dashboard, to manage any tax obligations & become tax efficient!"
                />
            </TopBar>
            <PageContent>
                <div className={classes('home-grid')}>
                    <div className={classes('quick-links-grid')}>
                        <Link href="/self-assessment">
                            <Button
                                type="secondary"
                                text="Personal Taxes"
                                icon="user"
                                iconPosition="left"
                                size="md"
                                className={classes('quick-link-button')}
                            />
                        </Link>
                        <Link href="/partnership">
                            <Button
                                type="secondary"
                                text="Partnership Taxes"
                                icon="users"
                                iconPosition="left"
                                size="md"
                                className={classes('quick-link-button')}
                            />
                        </Link>
                        <Link href="/company">
                            <Button
                                type="secondary"
                                text="LTD Company Taxes"
                                icon="corporate"
                                iconPosition="left"
                                size="md"
                                className={classes('quick-link-button')}
                            />
                        </Link>
                        <Link href="/referrals">
                            <Button
                                type="secondary"
                                text="Refer a friend"
                                icon="thumb"
                                iconPosition="left"
                                size="md"
                                className={classes('quick-link-button')}
                            />
                        </Link>
                    </div>
                    <Calendar />
                    <HMRCLinks />
                </div>
            </PageContent>
        </>
    )
}

const HMRCLinks = () => {
    return (
        <div className={classes('hmrc-links')}>
            <span className={classes('hmrc-title')}>HMRC Links</span>
            <p className={classes('link-description')}>
                We have provided a few HMRC links that we feel could be helpful to you:
            </p>
            <div className={classes('hmrc-link')}>
                <span className={classes('hmrc-subtitle')}>Contact HMRC</span>
                <p className={classes('hmrc-description')}>
                    Need to contact HMRC about a tax refund, address change or confirm a tax return? We'd recommend
                    using their digital chat. If you ask to be routed to a human advisor (twice), a HMRC agent will be
                    able to resolve your query.
                </p>
                <Button
                    type="text-primary"
                    text="Contact HMRC"
                    onClick={() => {
                        window.open(
                            'https://www.gov.uk/government/organisations/hm-revenue-customs/contact/self-assessment',
                            '_blank'
                        )
                    }}
                />
            </div>
            <div className={classes('hmrc-link')}>
                <span className={classes('hmrc-subtitle')}>Paying HMRC</span>
                <p className={classes('hmrc-description')}>
                    If you have a tax liability, you need to get this settled with HMRC by 31 January following the tax
                    year. There's a number of different ways to pay, click the link below for full details.
                </p>
                <Button
                    type="text-primary"
                    text="Pay HMRC"
                    onClick={() => {
                        window.open('https://www.gov.uk/pay-self-assessment-tax-bill', '_blank')
                    }}
                />
            </div>
        </div>
    )
}

export default Index
